import {AxiosResponse} from 'axios'
import {http} from 'hiya-common/src/utils/axios'
import {useEffect, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31608117#id-%E6%9E%9A%E4%B8%BE%E7%B1%BB%E5%9E%8B%E5%80%BC%E5%88%97%E8%A1%A8-%E6%A8%A1%E5%9D%97%E7%B1%BB%E5%9E%8B%E5%AE%9A%E4%B9%89(ModelType)
export enum ModelType {
  活动 = 1,
  积分 = 2,
  榜单 = 3,
  //   榜单奖励 = 4,
  //   奖励 = 5,
  抽奖系统 = 6,
  //   抽奖系统奖品 = 7,
  普通任务系统 = 8,
  //   普通任务系统任务 = 9,
  阶段任务系统 = 10,
  //   阶段任务系统阶段任务 = 11,
  兑换系统 = 12,
  爆奖系统 = 13,
}

// 榜单list结构类型 - 结构参考 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90608495
export enum RANKTYPE {
  用户结构 = 1,
  房间榜结构,
  公会榜榜结构,
  家族榜榜结构,
  国家榜榜结构,
}

export enum StageTaskStatusEnum {
  完成并领取奖励 = 2,
  完成未领取奖励 = 1,
  未完成 = 0,
}
export enum JobTypeEnum {
  普通任务 = 1,
  可重复完成任务 = 2,
}
export function useServeMap() {
  const deviceinfo = useSelector((store) => store.env.deviceinfo)
  return useMemo(() => {
    return {
      // http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612311
      [ModelType.活动]: ({id}) =>
        http.post<
          HiyaRes<{
            err_msg?: string
            activity_expire: number
            activity_dates: Array<string>
            day_of_activity: number
            rank_active_period: any
            user_info: {
              is_new_user: {
                value: number
                expire_secs: number
              }
              is_union_anchor: boolean // 是否工会主播
              union_country: number // 工会所在国家code
              is_vip_user: boolean // 是否是 vip 用户
              room_id: number // 房间id
            }
          }>
        >('/live/commonactivity/get_activity_info', {
          activity_id: id,
          ...deviceinfo,
        }),
      [ModelType.积分]: ({id, room_id = 0}) =>
        http.post<
          HiyaRes<{
            score: number
          }>
        >('/live/commonactivity/get_counter_score', {
          score_id: id,
          room_id,
          ...deviceinfo,
        }),
      // https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35193996
      [ModelType.榜单]: ({
        id,
        peroid_offset = 0,
        offset = 0,
        limit = 0,
        upper_dimen_id = null,
      }) =>
        http.post<
          HiyaRes<{
            rank_type: number
            list: any
            own: any
            rank_expire: number
            offset: number
          }>
        >('/live/commonactivity/get_rank_info', {
          rank_id: id,
          peroid_offset,
          offset,
          limit,
          upper_dimen_id,
          ...deviceinfo,
        }),
      // https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35770770
      [ModelType.普通任务系统]: ({id, latest_records = 0}) =>
        http.post<
          HiyaRes<{
            expire_secs: number
            job_list: Array<{
              job_id: number
              job_name: string
              job_icon: string
              job_status: number
              job_need: number
              job_dones: number
              job_max_times: number
              job_done_times: number
              job_type: number
              reward_list: Array<[string, string]>
            }>
          }>
        >('/live/commonactivity/get_jobsystem_info', {
          job_system_id: id,
          latest_records,
          ...deviceinfo,
        }),
      // http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612485
      [ModelType.阶段任务系统]: ({id, event_room = 0}) =>
        http.post<
          HiyaRes<{
            expire_secs: number
            stage_score: number
            stages: Array<{
              // 序号
              stage_no: number
              // 完成所需数量
              stage_need: number
              status: StageTaskStatusEnum
              stage_icon: string
              reward_list: [string, string][]
            }>
          }>
        >('/live/commonactivity/get_stage_task_info', {
          task_id: id,
          event_room,
          ...deviceinfo,
        }),
      // http://wiki.xunlei.cn/pages/viewpage.action?pageId=96306479
      [ModelType.兑换系统]: ({id, event_room = 0}) =>
        http.post<
          HiyaRes<{
            list: Array<{
              // 序号
              id: number
              name: string
              icon: string
              coin_worth: number
              coin_need: number
              gamestone_need: number
              reward_list: [string, string][]
              score_needs: {score_id: number; name: string; num: number}[]
              left_times: number
              can_exchange: boolean
            }>
            ticket_info: {
              coin_amount: number
              gamestone_amount: number
              score_items: Array<{
                score_id: number
                name: string
                num: number
              }>
            }
          }>
        >('/live/commonactivity/get_store_goods_list', {
          exg_system_id: id,
          event_room,
          ...deviceinfo,
        }),
      // http://wiki.xunlei.cn/pages/viewpage.action?pageId=117025673
      [ModelType.爆奖系统]: ({id, event_room = 0}) =>
        http.post<
          HiyaRes<{
            expire_secs: number
            stage_score: number
            stages: Array<{
              // 序号
              stage_no: number
              // 完成所需数量
              stage_need: number
              status: StageTaskStatusEnum
              stage_icon: string
              reward_list: [string, string][]
            }>
          }>
        >('/live/commonactivity/get_bonus_info', {
          bonus_id: id,
          event_room,
          ...deviceinfo,
        }),
      // http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612314
      [ModelType.抽奖系统]: ({id}) =>
        http.post<
          HiyaRes<{
            ticket_num: number // 剩余抽奖券数量
            ticket_type: number // 1: 金币;2:宝石;3:抽奖积分
            ticket_cost: number // 单次抽奖消耗抽奖券数量
            prize_list: {
              id: number
              name: string
              icon: string
              value: number
            }[] // 奖励list
          }>
        >('/live/commonactivity/get_lottery_info', {
          lottery_id: id,
          ...deviceinfo,
        }),
    }
  }, [deviceinfo])
}

export type ReturnPromiseType<T> = T extends Promise<infer P> ? P : T
export function useModuleId<T extends ModelType>({
  type,
  logic_id,
}: {
  type: T
  logic_id: number
}) {
  const module_ids = useSelector((store) => store.ToyBricks.module_ids) || {}
  const module_id = module_ids[type] ? module_ids[type][logic_id] : null
  return module_id
}
/**
 * @description: 积木系统各模块服务hook
 * @param {
 *  type 模块id,
 *  logic_id 该模块某条配置的唯一id，根据唯一id可以找到该配置测试正式id
 * }
 * @return null | 每个模块serveMap配置的服务的返回值
 */
export function useServe<
  T extends ModelType.阶段任务系统,
  DATA extends AxiosResponse<HiyaRes<any>> = ReturnPromiseType<
    ReturnType<ReturnType<typeof useServeMap>[T]>
  >
>({type, logic_id, fresh}: {type: T; logic_id: number; fresh?: boolean}) {
  const serveMap = useServeMap()

  const module_id = useModuleId({type, logic_id})

  const [data, setData] = useState<DATA['data']['data']>({})
  useEffect(() => {
    if (module_id) {
      serveMap[type]({
        id: module_id,
      }).then((v: DATA) => {
        setData(() => {
          return v.data.data
        })
      })
    }
  }, [module_id, fresh])
  const ret: {
    data: typeof data
    setData: typeof setData
    module_id: typeof module_id
  } & [typeof data, typeof setData, typeof module_id] = [
    data,
    setData,
    module_id,
  ] as any
  ret.data = data
  ret.setData = setData
  ret.module_id = module_id
  return ret
}
// 阶段任务系统领取奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38788766
// export function getStageDoneReward({setData}) {

// }
